"use strict";exports.__esModule = true;exports.default = void 0;var _default = {
  handleCollapse(_ref) {var { originalEvent } = _ref;
    if (this.state.expanded) {
      this.state.expanded = false;
      this.emit('collapse', { originalEvent });
    }
  },

  handleExpand(_ref2) {var { originalEvent } = _ref2;
    if (!this.state.expanded) {
      this.state.expanded = true;
      this.emit('expand', { originalEvent });
    }
  },
  onInput(input) {
    if (input.open === false || input.open === true) {
      this.state.expanded = input.open;
    }
  },

  onCreate() {
    this.state = {
      expanded: true
    };
  }
};exports.default = _default;module.exports = exports.default;